var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _ellipse, _path8, _path9, _path0, _ellipse2, _path1, _path10, _path11, _ellipse3, _path12, _path13, _path14, _ellipse4, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetingsThisweek(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "videoconference",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.583,
    height: 74.411,
    viewBox: "0 0 74.583 74.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54451",
    "data-name": "Path 54451",
    d: "M80.26,70.518H19.954A4.954,4.954,0,0,1,15,65.564V20.542a4.954,4.954,0,0,1,4.954-4.954H80.26a4.954,4.954,0,0,1,4.954,4.954V65.564A4.954,4.954,0,0,1,80.26,70.518Z",
    transform: "translate(-12.816 -13.404)",
    fill: "#cef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54452",
    "data-name": "Path 54452",
    d: "M286.205,15.588H256.044v54.93h30.161a4.954,4.954,0,0,0,4.954-4.954V20.542a4.954,4.954,0,0,0-4.954-4.954Z",
    transform: "translate(-218.761 -13.404)",
    fill: "#fff1ae"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54453",
    "data-name": "Path 54453",
    d: "M15,204.2v22.511a4.954,4.954,0,0,0,4.954,4.954H80.26a4.954,4.954,0,0,0,4.954-4.954V204.2Z",
    transform: "translate(-12.816 -174.554)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54454",
    "data-name": "Path 54454",
    d: "M256.044,204.2v27.465h30.161a4.954,4.954,0,0,0,4.954-4.954V204.2Z",
    transform: "translate(-218.761 -174.554)",
    fill: "#41a1ee"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54455",
    "data-name": "Path 54455",
    d: "M173.041,407.944l2.375-15.126h19.352l2.131,15.124Z",
    transform: "translate(-147.844 -335.704)",
    fill: "#64b5f6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54456",
    "data-name": "Path 54456",
    d: "M256.044,407.949h11.773l-2.131-15.124h-9.641Z",
    transform: "translate(-218.761 -335.709)",
    fill: "#64b5f6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47267",
    "data-name": "Group 47267",
    transform: "translate(17.83 70.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54457",
    "data-name": "Path 54457",
    d: "M159.187,485.976H124.633a2.184,2.184,0,0,1,0-4.368h34.554a2.184,2.184,0,1,1,0,4.368Z",
    transform: "translate(-122.449 -481.608)",
    fill: "#0089ff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54458",
    "data-name": "Path 54458",
    d: "M273.329,481.608H256.044v4.368h17.285a2.184,2.184,0,0,0,0-4.368Z",
    transform: "translate(-218.761 -411.565)",
    fill: "#295fcc"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2754",
    "data-name": "Ellipse 2754",
    cx: 5.043,
    cy: 5.043,
    rx: 5.043,
    ry: 5.043,
    transform: "translate(49.288 36.612)",
    fill: "#ffa64d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54459",
    "data-name": "Path 54459",
    d: "M373.119,252.019V262.1a5.043,5.043,0,0,0,0-10.085Z",
    transform: "translate(-318.788 -215.407)",
    fill: "#f93"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54460",
    "data-name": "Path 54460",
    d: "M327.138,326.637h-6.617a5.091,5.091,0,0,0-5.051,5.09v1.143A1.333,1.333,0,0,0,316.8,334.2H330.9a1.333,1.333,0,0,0,1.333-1.333v-1.143A5.091,5.091,0,0,0,327.138,326.637Z",
    transform: "translate(-269.534 -279.16)",
    fill: "#7affe4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54461",
    "data-name": "Path 54461",
    d: "M376.391,326.637h-3.273V334.2h7.032a1.333,1.333,0,0,0,1.333-1.333v-1.143A5.091,5.091,0,0,0,376.391,326.637Z",
    transform: "translate(-318.787 -279.16)",
    fill: "#00ecce"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2755",
    "data-name": "Ellipse 2755",
    cx: 5.043,
    cy: 5.043,
    rx: 5.043,
    ry: 5.043,
    transform: "translate(15.299 36.612)",
    fill: "#fc9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54462",
    "data-name": "Path 54462",
    d: "M139.695,252.019V262.1a5.043,5.043,0,1,0,0-10.085Z",
    transform: "translate(-119.354 -215.407)",
    fill: "#ffb366"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54463",
    "data-name": "Path 54463",
    d: "M93.715,326.637H87.1a5.091,5.091,0,0,0-5.051,5.09v1.143A1.333,1.333,0,0,0,83.38,334.2H97.473a1.333,1.333,0,0,0,1.333-1.333v-1.143A5.092,5.092,0,0,0,93.715,326.637Z",
    transform: "translate(-70.1 -279.16)",
    fill: "#ff9100"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54464",
    "data-name": "Path 54464",
    d: "M142.967,326.637h-3.273V334.2h7.032a1.333,1.333,0,0,0,1.333-1.333v-1.143A5.092,5.092,0,0,0,142.967,326.637Z",
    transform: "translate(-119.353 -279.16)",
    fill: "#ff641a"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2756",
    "data-name": "Ellipse 2756",
    cx: 5.043,
    cy: 5.043,
    rx: 5.043,
    ry: 5.043,
    transform: "translate(49.288 11.214)",
    fill: "#ffa64d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54465",
    "data-name": "Path 54465",
    d: "M373.119,77.6V87.684a5.043,5.043,0,0,0,0-10.085Z",
    transform: "translate(-318.788 -66.385)",
    fill: "#f93"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54466",
    "data-name": "Path 54466",
    d: "M327.138,152.217h-6.617a5.091,5.091,0,0,0-5.051,5.09v1.143a1.333,1.333,0,0,0,1.333,1.333H330.9a1.333,1.333,0,0,0,1.333-1.333v-1.143A5.092,5.092,0,0,0,327.138,152.217Z",
    transform: "translate(-269.534 -130.138)",
    fill: "#ffda2d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54467",
    "data-name": "Path 54467",
    d: "M376.391,152.217h-3.273v7.568h7.032a1.333,1.333,0,0,0,1.333-1.333v-1.143A5.091,5.091,0,0,0,376.391,152.217Z",
    transform: "translate(-318.787 -130.138)",
    fill: "#fdbf00"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2757",
    "data-name": "Ellipse 2757",
    cx: 5.043,
    cy: 5.043,
    rx: 5.043,
    ry: 5.043,
    transform: "translate(15.299 11.214)",
    fill: "#fc9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54468",
    "data-name": "Path 54468",
    d: "M139.695,77.6V87.684a5.043,5.043,0,0,0,0-10.085Z",
    transform: "translate(-119.354 -66.385)",
    fill: "#ffb366"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54469",
    "data-name": "Path 54469",
    d: "M93.715,152.217H87.1a5.091,5.091,0,0,0-5.051,5.09v1.143a1.333,1.333,0,0,0,1.333,1.333H97.473a1.333,1.333,0,0,0,1.333-1.333v-1.143A5.092,5.092,0,0,0,93.715,152.217Z",
    transform: "translate(-70.1 -130.138)",
    fill: "#ff405c"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54470",
    "data-name": "Path 54470",
    d: "M142.967,152.217h-3.273v7.568h7.032a1.333,1.333,0,0,0,1.333-1.333v-1.143A5.092,5.092,0,0,0,142.967,152.217Z",
    transform: "translate(-119.353 -130.138)",
    fill: "#c1126b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54471",
    "data-name": "Path 54471",
    d: "M68.022,59.886H6.561A6.561,6.561,0,0,1,0,53.325V7.149A6.561,6.561,0,0,1,6.561.588H68.022a6.561,6.561,0,0,1,6.561,6.561V53.325a6.561,6.561,0,0,1-6.561,6.561ZM6.561,4.956A2.192,2.192,0,0,0,4.368,7.149V53.325a2.192,2.192,0,0,0,2.192,2.192H68.022a2.192,2.192,0,0,0,2.192-2.192V7.149a2.192,2.192,0,0,0-2.192-2.192H6.561Z",
    transform: "translate(0 -0.588)",
    fill: "#64b5f6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54472",
    "data-name": "Path 54472",
    d: "M287.333.588H256.044V4.956h31.289A1.642,1.642,0,0,1,288.975,6.6V53.188a2.33,2.33,0,0,1-2.33,2.33h-30.6v4.368h31.289a6.01,6.01,0,0,0,6.01-6.01V6.6a6.01,6.01,0,0,0-6.01-6.01Z",
    transform: "translate(-218.761 -0.588)",
    fill: "#64b5f6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingsThisweek);
export default __webpack_public_path__ + "static/media/meetings-thisweek.7115df17b46dc8285bbe5de4360fbf47.svg";
export { ForwardRef as ReactComponent };